/**
 * Stable CSS class names for E2E — Customer payment logs.
 */
export const CPL = {
    page: 'customer-payment-logs-page',
    paperFilters: 'customer-payment-logs-page__paper-filters',
    sectionTitle: 'customer-payment-logs-page__section-title',
    filtersRow: 'customer-payment-logs-page__filters-row',
    inputTextfieldOrderNo: 'customer-payment-input--textfield-order-no',
    fieldDateRange: 'customer-payment-logs-field--date-range',
    inputButtonSearch: 'customer-payment-input--button-search',
    fieldHelperText: 'customer-payment-logs-field--helper-text',
    paperResults: 'customer-payment-logs-page__paper-results',
    datagrid: 'customer-payment-logs-page__datagrid',

    modal: 'customer-payment-logs-modal',
    modalContent: 'customer-payment-logs-modal__content',
    modalHeader: 'customer-payment-logs-modal__header',
    inputIconButtonModalClose: 'customer-payment-input--icon-button-modal-close',
    jsonPre: 'customer-payment-logs-modal__json-pre',
    modalNavRow: 'customer-payment-logs-modal__nav-row',
    inputIconButtonModalPrev: 'customer-payment-input--icon-button-modal-prev',
    inputIconButtonModalNext: 'customer-payment-input--icon-button-modal-next',
    inputLinkResponseData: 'customer-payment-input--link-response-data',
} as const;

export const cplCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
